
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.40065 15.5169H4.60065C1.99398 15.5169 0.833984 14.3569 0.833984 11.7503V8.95026C0.833984 6.34359 1.99398 5.18359 4.60065 5.18359H7.40065C10.0073 5.18359 11.1673 6.34359 11.1673 8.95026V11.7503C11.1673 14.3569 10.0073 15.5169 7.40065 15.5169ZM4.60065 6.18359C2.53398 6.18359 1.83398 6.88359 1.83398 8.95026V11.7503C1.83398 13.8169 2.53398 14.5169 4.60065 14.5169H7.40065C9.46732 14.5169 10.1673 13.8169 10.1673 11.7503V8.95026C10.1673 6.88359 9.46732 6.18359 7.40065 6.18359H4.60065Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.4007 11.5169H10.6673C10.394 11.5169 10.1673 11.2903 10.1673 11.0169V8.95026C10.1673 6.88359 9.46732 6.18359 7.40065 6.18359H5.33398C5.06065 6.18359 4.83398 5.95693 4.83398 5.68359V4.95026C4.83398 2.34359 5.99398 1.18359 8.60065 1.18359H11.4007C14.0073 1.18359 15.1673 2.34359 15.1673 4.95026V7.75026C15.1673 10.3569 14.0073 11.5169 11.4007 11.5169ZM11.1673 10.5169H11.4007C13.4673 10.5169 14.1673 9.81693 14.1673 7.75026V4.95026C14.1673 2.88359 13.4673 2.18359 11.4007 2.18359H8.60065C6.53398 2.18359 5.83398 2.88359 5.83398 4.95026V5.18359H7.40065C10.0073 5.18359 11.1673 6.34359 11.1673 8.95026V10.5169Z","fill":"currentColor"}})])
          )
        }
      }
    